// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

import { EventType } from "../common/Exports";

/**
 * Define event severity types for setting logging output.
 * @class LogLevel
 */

export { EventType as LogLevel };
